import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { FiscalDocumentIssuerData } from "../types/fiscalDocumentIssuer.type";

type useCompanyBranchWithFiscalDocumentIssuerDataType = ({ }: { id?: string; }) => UseQueryResult<FiscalDocumentIssuerData, unknown>;

const useCompanyBranchWithFiscalDocumentIssuerData: useCompanyBranchWithFiscalDocumentIssuerDataType = ({ id }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<{ data: { data: FiscalDocumentIssuerData; }; }, unknown, FiscalDocumentIssuerData>({
    enabled: !!id,
    queryKey: ['companyBranchWithFiscalDocument', id],
    queryFn: () => {
      return privateAxios.get(`/client/company_branches/${id}/with_fiscal_document_issuer_data`);
    },
    select: (data) => data?.data?.data,
  });
};

export default useCompanyBranchWithFiscalDocumentIssuerData;
